module.exports = __webpack_public_path__ + "static/media/shoes.c8a66b0b.png";